import { NumberLine as NumberLineIcon } from "assets/icons";
import { DropdownSetting, InformationSetting, RememberSettings } from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { NumberLine, NumberLineState } from "./NumberLine";
import { NumberLineIntervalSetting } from "./NumberLineIntervalSetting";

export const NumberLineWidget: WidgetType<NumberLineState> = {
  name: "Number Line",
  component: NumberLine,
  icon: NumberLineIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 390,
    minHeight: 217,
    minAspectRatio: 1.8,
    maxAspectRatio: 1.8,
  },
  defaultState: {
    spans: [],
    hideNumbers: false,
  },
  defaultSize: {
    aspectRatio: 1.8,
    widthPercentage: 60,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Manipulate a virtual number line to explore counting, addition, subtraction, and fractions interactively.",
      },
    },
    interval: {
      editor: NumberLineIntervalSetting,
      info: {},
      defaultValue: { startNumber: 0, endNumber: 20 },
    },
    stepSize: {
      editor: DropdownSetting,
      info: {
        name: "Step Size",
        options: [
          "Whole Numbers",
          "Decimals (Tenths)",
          "Fractions (Halves)",
          "Fractions (Thirds)",
          "Fractions (Quarters)",
        ],
      },
      defaultValue: "Whole Numbers",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.numberLine,
        widgetDisplayName: "Number Line",
      },
    },
  },
  quickActions: {},
};
